import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Modal, Form, Input, Typography } from 'antd';
import { ModalComponent } from '@lib/common';
import { buildPromptText, extractFormFields } from './suggestion-item-modal.helpers';
import { formatTemplateWithBlanks } from './suggestion-item-modal.hooks';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Text = Typography.Text;
var StyledForm = styled(Form).withConfig({
  displayName: "suggestion-item-modalcomponent__StyledForm",
  componentId: "sc-152osor-0"
})(["height:100%;"]);
var StyledPreviewWrapper = styled.div.withConfig({
  displayName: "suggestion-item-modalcomponent__StyledPreviewWrapper",
  componentId: "sc-152osor-1"
})(["border-bottom:1px solid #f0f0f0;margin-bottom:16px;"]);
var StyledPreviewContent = styled.div.withConfig({
  displayName: "suggestion-item-modalcomponent__StyledPreviewContent",
  componentId: "sc-152osor-2"
})(["padding:12px;background-color:#f9f9f9;border-radius:6px;"]);
var StyledFieldsContainer = styled.div.withConfig({
  displayName: "suggestion-item-modalcomponent__StyledFieldsContainer",
  componentId: "sc-152osor-3"
})(["max-height:50vh;overflow-y:auto;padding-right:12px;padding-left:4px;padding-top:4px;padding-bottom:4px;&::-webkit-scrollbar{width:6px;}&::-webkit-scrollbar-thumb{background:#ccc;border-radius:4px;}&::-webkit-scrollbar-track{background:transparent;}"]);
var StyledInput = styled(Input).withConfig({
  displayName: "suggestion-item-modalcomponent__StyledInput",
  componentId: "sc-152osor-4"
})(["width:100%;"]);
export var SuggestionItemModal = function SuggestionItemModal(_ref) {
  var item = _ref.item,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var formValues = Form.useWatch([], form) || {};
  var template = (item === null || item === void 0 ? void 0 : item.promptText) || '';
  var formFields = extractFormFields(template);

  var handleOk = function handleOk() {
    form.validateFields().then(function (values) {
      var updatedPromptText = buildPromptText(values, template);
      onSubmit(updatedPromptText);
    });
  };

  var handleCancel = function handleCancel() {
    var isFormModified = form.isFieldsTouched();

    if (isFormModified) {
      Modal.confirm({
        title: 'Discard changes?',
        icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {}),
        content: 'You have unsaved changes. Are you sure you want to close this window?',
        okText: 'Yes, discard',
        okType: 'danger',
        cancelText: 'No, keep editing',
        onOk: function onOk() {
          onCancel();
        }
      });
    } else {
      onCancel();
    }
  };

  return /*#__PURE__*/_jsx(ModalComponent, {
    centered: true,
    title: item === null || item === void 0 ? void 0 : item.title,
    open: true,
    onCancel: handleCancel,
    onOk: handleOk,
    keyboard: !form.isFieldsTouched(),
    width: 750,
    cancelButtonTitle: "Cancel",
    confirmButtonTitle: "Confirm",
    children: /*#__PURE__*/_jsxs(StyledForm, {
      form: form,
      layout: "vertical",
      autoComplete: "off",
      children: [/*#__PURE__*/_jsx(StyledPreviewWrapper, {
        children: /*#__PURE__*/_jsx(Form.Item, {
          label: "Preview",
          style: {
            marginBottom: 0
          },
          children: /*#__PURE__*/_jsx(StyledPreviewContent, {
            children: /*#__PURE__*/_jsx(Text, {
              children: formatTemplateWithBlanks(template, formValues)
            })
          })
        })
      }), /*#__PURE__*/_jsx(StyledFieldsContainer, {
        children: formFields.map(function (field) {
          return /*#__PURE__*/_jsx(Form.Item, {
            label: field.label,
            name: field.fieldName,
            rules: [{
              required: true,
              message: "Please input ".concat(field.label.toLowerCase())
            }],
            children: /*#__PURE__*/_jsx(StyledInput, {
              placeholder: "Enter ".concat(field.label.toLowerCase())
            })
          }, field.fieldName);
        })
      })]
    })
  });
};